const initMarquee = () => {
    const marquee = document.querySelectorAll('.logo-marquee__wrapper');

    if (!marquee.length) {
      return;
    }

    marquee.forEach((item) => {
      const duration = parseInt(item.getAttribute("duration"), 10) || 5;
      const reverse = item.getAttribute('reverse') === 'true';
      const marqueeContent = item.firstElementChild;
      if (!marqueeContent) {
        return;
      }

      const marqueeContentClone = marqueeContent.cloneNode(true);
      item.appendChild(marqueeContentClone);

      let tween;
      const playMarquee = () => {
        let progress = tween? tween.progress() : 0;
        tween && tween.progress(0).kill();
        const width = parseInt(getComputedStyle(marqueeContent).getPropertyValue("width"), 10);
        const gap = parseInt(getComputedStyle(marqueeContent).getPropertyValue("column-gap"), 10);
        const distanceToTranslate = -1 * (gap + width);
        if (!reverse) {
          tween = gsap.fromTo(
            item.children,
            { x: 0 },
            { x: distanceToTranslate, duration, ease: "none", repeat: -1 }
          );
        } else {
          tween = gsap.fromTo(
            item.children,
            { x: distanceToTranslate },
            { x: 0, duration, ease: "none", repeat: -1 }
          );
        }

        tween.progress(progress);
      };
      playMarquee();

      function debounce(func) {
        var timer;
        return function (event) {
          if (timer) clearTimeout(timer);
          timer = setTimeout(
            () => {
              func();
            },
            500,
            event
          );
        };
      }

      window.addEventListener("resize", debounce(playMarquee));
    });
  };

  document.addEventListener("DOMContentLoaded", initMarquee);